import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import TransactionFileFactory from "../../Entity/Factories/TransactionFileFactory";
export default function* transactionFileData(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `transaction-file/${action.payload?.id}`);

    const transactionFile = TransactionFileFactory.create(res.data)

    yield put({
      type: Constants.GLOBAL_TRANSACTION_FILE_DATA_SUCCESS,
      payload: {
        transactionFile: transactionFile
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, transactionFile);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchTransactionFileData() {
  yield takeEvery(Constants.GLOBAL_TRANSACTION_FILE_DATA_START, transactionFileData);
}
